const PARTICULARES_KEY = 'app_particulares';
const ACTIVE_PARTICULAR_KEY = 'app_particular_activo';
const ACTIVE_PARTICULAR_ID_KEY = 'app_particular_activo_id';
const PERMISOS_KEY = 'app_particular_permisos';
export const PARTICULAR_PERMISOS_EVENT = 'particular-permisos-updated';

const getParticularId = (particular) => particular?.id || particular?.Id || null;

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Error guardando particular en localStorage:', key, error);
  }
};

const safeGetItem = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    console.error('Error leyendo particular desde localStorage:', key, error);
    return fallback;
  }
};

const ParticularService = {
  setParticulares(particulares = []) {
    safeSetItem(PARTICULARES_KEY, Array.isArray(particulares) ? particulares : []);
  },

  getParticulares() {
    return safeGetItem(PARTICULARES_KEY, []);
  },

  setActiveParticular(particular) {
    safeSetItem(ACTIVE_PARTICULAR_KEY, particular || null);
    safeSetItem(ACTIVE_PARTICULAR_ID_KEY, getParticularId(particular));
  },

  getActiveParticular() {
    return safeGetItem(ACTIVE_PARTICULAR_KEY, null);
  },

  getActiveParticularId() {
    return safeGetItem(ACTIVE_PARTICULAR_ID_KEY, null);
  },

  syncActiveParticular(particular) {
    const particularId = getParticularId(particular);
    if (!particularId) return null;

    const particulares = this.getParticulares();
    const activeParticular = this.getActiveParticular();
    const activeParticularId = getParticularId(activeParticular);
    const existing = particulares.find((item) => String(getParticularId(item)) === String(particularId));
    const merged = {
      ...(existing || {}),
      ...(String(activeParticularId || '') === String(particularId) ? activeParticular : {}),
      ...particular
    };
    const updatedParticulares = existing
      ? particulares.map((item) => (
          String(getParticularId(item)) === String(particularId) ? merged : item
        ))
      : [...particulares, merged];

    this.setParticulares(updatedParticulares);
    this.setActiveParticular(merged);
    return merged;
  },

  // Permisos del usuario en la cuenta activa (vienen de /particulares/contexto). Los usa el menú lateral.
  setPermisos(particularId, contexto) {
    if (!particularId || !contexto) return;
    const profesores = Boolean(contexto.puedeGestionarProfesores ?? contexto.PuedeGestionarProfesores);
    const permisos = {
      particularId: String(particularId),
      profesores,
      invitaciones: profesores,
      cuentaCorriente: Boolean(contexto.puedeGestionarCuentaCorriente ?? contexto.PuedeGestionarCuentaCorriente),
      entidades: Boolean(contexto.puedeGestionarEntidades ?? contexto.PuedeGestionarEntidades),
      modoColegio: Boolean((contexto.particular || contexto.Particular)?.modoColegio ?? (contexto.particular || contexto.Particular)?.ModoColegio)
    };
    safeSetItem(PERMISOS_KEY, permisos);
    try {
      window.dispatchEvent(new CustomEvent(PARTICULAR_PERMISOS_EVENT, { detail: permisos }));
    } catch (_) {
      // Sin window (tests): no hace falta avisar.
    }
  },

  getPermisos(particularId) {
    const permisos = safeGetItem(PERMISOS_KEY, null);
    if (!permisos || !particularId || permisos.particularId !== String(particularId)) return null;
    return permisos;
  },

  clearParticularData() {
    try {
      localStorage.removeItem(PERMISOS_KEY);
      localStorage.removeItem(PARTICULARES_KEY);
      localStorage.removeItem(ACTIVE_PARTICULAR_KEY);
      localStorage.removeItem(ACTIVE_PARTICULAR_ID_KEY);
    } catch (error) {
      console.error('Error limpiando datos de particulares:', error);
    }
  }
};

export default ParticularService;
